import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import styles from './FinancialTableRowContainer.style';
import FinancialTableRow from '../FinancialTableRow';

const FinancialTableRowContainer = ({ collapsibleSubLineItems, item }) => {
  const {
    name,
    amount,
    currency,
    purchasedUnits,
    returnCap,
    capLimit,
    actualReturns,
    returnsOverCap,
    returnsIncluded,
    isPerCap,
    parenthesizeDetails,
    parenthesizeIfNegative,
    href,
    bold,
    details,
  } = item;

  const [isCollapsed, setCollapsed] = useState(collapsibleSubLineItems);
  const toggleCollapse = () => setCollapsed(!isCollapsed);

  return (
    <>
      {collapsibleSubLineItems && details && details.length > 0 && (
        <button
          className={styles.collapseButton}
          type="button"
          aria-label="expand collapse sublineitems"
          aria-expanded={isCollapsed}
          data-selection-disabled="true"
          onClick={toggleCollapse}
        >
          <FontIcon
            iconName={isCollapsed ? 'ChevronRight' : 'ChevronDown'}
            className={styles.rightIcon}
          />
        </button>
      )}
      <FinancialTableRow
        name={name}
        amount={amount}
        currency={currency}
        key={name}
        returnCap={returnCap}
        capLimit={capLimit}
        actualReturns={actualReturns}
        returnsOverCap={returnsOverCap}
        returnsIncluded={returnsIncluded}
        purchasedUnits={purchasedUnits}
        parenthesizeIfNegative={parenthesizeIfNegative}
        href={href}
        bold={bold}
        isPerCap={isPerCap}
      />
      {!isCollapsed &&
        details?.map(detail => {
          return (
            <FinancialTableRow
              commentId={detail.commentId}
              name={detail.name}
              amount={isPerCap ? detail.amountReturned : detail.amount}
              key={detail.name}
              returnCap={detail.returnCap}
              capLimit={detail.capLimit}
              actualReturns={detail.actualReturns}
              returnsOverCap={detail.returnsOverCap}
              returnsIncluded={detail.returnsIncluded}
              purchasedUnits={detail.purchasedUnits}
              currency={detail.currency ? detail.currency : currency}
              parenthesize={parenthesizeDetails}
              parenthesizeIfNegative={parenthesizeIfNegative}
              href={detail.href}
              bold={bold}
              isPerCap={isPerCap}
              isDetail
            />
          );
        })}
    </>
  );
};

FinancialTableRowContainer.propTypes = {
  collapsibleSubLineItems: PropTypes.bool,
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string,
    returnsCap: PropTypes.number,
    capLimit: PropTypes.number,
    actualReturns: PropTypes.number,
    returnsOverCap: PropTypes.number,
    returnsIncluded: PropTypes.number,
    purchasedUnits: PropTypes.number,
    isPerCap: PropTypes.bool,
    parenthesizeDetails: PropTypes.bool,
    parenthesizeIfNegative: PropTypes.bool,
    href: PropTypes.string,
    bold: PropTypes.bool,
    returnCap: PropTypes.number,
    details: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
        returnsCap: PropTypes.number,
        capLimit: PropTypes.number,
        actualReturns: PropTypes.number,
        returnsOverCap: PropTypes.number,
        returnsIncluded: PropTypes.number,
        href: PropTypes.string,
      }),
    ),
  }).isRequired,
};

FinancialTableRowContainer.defaultProps = {
  collapsibleSubLineItems: false,
};

export default FinancialTableRowContainer;
